export default __webpack_public_path__ + "static/media/BarlowCondensed-Regular.db83f781.woff2";